import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}`;

function auth(extra = {}) {
  return { headers: buildHeaders({}, extra) };
}

export default {
  listForEmployee(employeeId) {
    return axios.get(`${API_URL}employees/${employeeId}/onboarding-documents`, auth());
  },

  createForEmployee(employeeId, formData) {
    return axios.post(`${API_URL}employees/${employeeId}/onboarding-documents`, formData, auth({ multipart: true }));
  },

  replaceForEmployee(employeeId, documentId, formData) {
    return axios.post(
      `${API_URL}employees/${employeeId}/onboarding-documents/${documentId}/file`,
      formData,
      auth({ multipart: true })
    );
  },

  removeForEmployee(employeeId, documentId) {
    return axios.delete(`${API_URL}employees/${employeeId}/onboarding-documents/${documentId}`, auth());
  },

  mine() {
    return axios.get(`${API_URL}employees/me/onboarding-documents`, auth());
  },

  uploadMine(documentId, formData) {
    return axios.post(
      `${API_URL}employees/me/onboarding-documents/${documentId}/file`,
      formData,
      auth({ multipart: true })
    );
  },

  signMine(documentId, payload) {
    return axios.post(`${API_URL}employees/me/onboarding-documents/${documentId}/sign`, payload, auth());
  },

  download(url) {
    return axios.get(url, { ...auth(), responseType: "blob" });
  },

  employeeFileUrl(employeeId, documentId, part = "file") {
    return `${API_URL}employees/${employeeId}/onboarding-documents/${documentId}/${part}`;
  },

  mineFileUrl(documentId, part = "file") {
    return `${API_URL}employees/me/onboarding-documents/${documentId}/${part}`;
  },
};
